var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page-wrapper"},[_c('Header',{attrs:{"data":_vm.$props}}),_c('div',{staticClass:"main-content"},[_vm._t("default")],2),(_vm.footerStyle === 1)?_c('Footer',{attrs:{"data":_vm.$props}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }